import React from 'react'
import { compose } from 'redux'
import { withFormik } from 'formik'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'

import Title from '../../views/typo/Title'
import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import Button from '../../views/buttons/Button'
import { withAppRouterHandler } from '../../../modules/portal/withPortalIdByRoute'
import { setInfo } from '../../../actions/info'
import Logo from './Logo'

const SigninBox = ({
  values,
  errors,
  isValid,
  onSubmit,
  handleChange,
  handleBlur,
  handleSubmit,
}) => (
  <div className="columns is-centered">
    <div className="column is-4">
      <div className="card">
        <div className="card-content">
          <form onSubmit={onSubmit} className="content">
            <Logo />
            <hr />
            <Title>Sign In</Title>
            <Field isHorizontal={false} label="Passcode">
              <InputText
                name="passcode"
                type="password"
                value={values.passcode}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.passcode}
              />
            </Field>
            <Button
              onClick={handleSubmit}
              disabled={!isValid}
              className="is-info is-fullwidth"
            >
              SIGN IN
            </Button>

            {
              // <hr/>
              // <div className="has-text-centered">
              //   <small>โครงการ Innovation Hubs <br/>
              //   เพื่อสร้างเศรษฐกิจฐานนวัตกรรมของประเทศตามนโยบายประเทศไทย 4.0
              //   </small>
              // </div>
            }
          </form>
        </div>
      </div>
    </div>
  </div>
)

export default compose(
  withAppRouterHandler,
  connect(null, { setInfo }),
  withFormik({
    mapPropsToValues: props => ({ passcode: '' }),
    handleSubmit: (values, { props }) => {
      props.setInfo('passcode', values.passcode)
      props.redirectToMenuPage()
    },
    validate: values => {
      const errors = {}
      if (isEmpty(values.passcode)) errors.passcode = 'Required'
      return errors
    },
    isInitialValid: false,
  }),
)(SigninBox)



// WEBPACK FOOTER //
// ./src/components/templates/signin/SigninBox.js